import { Link } from "@/lib/link";
import { Button } from "@/components/ui/button";

export default function NotFound() {
    return (
        <section className="min-h-screen flex items-center justify-center bg-[#F8FAFC] pt-24 pb-24">
            <div className="container-x text-center max-w-lg">
                <div className="overline">404</div>
                <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold text-[#0A2540]">Page not found.</h1>
                <p className="mt-4 text-slate-500">The link you followed may be broken, or the page may have been moved.</p>
                <Link to="/" className="inline-block mt-8"><Button className="rounded-full bg-[#1D4ED8] px-7 py-6">Back to home</Button></Link>
            </div>
        </section>
    );
}
